import { lazy } from 'react';

/** Открывает список тегов */
export const TagsPageAsync = lazy(() => import('./Tags/TagsPage'));
